import { Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { CookieService } from 'ngx-cookie-service';
import { UserDataService } from './user-data.service';
import { UiLanguage } from '../interfaces/user-interfaces';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private availableLanguages: string[] = ['en', 'it'];
  private defaultLanguage: string = 'en';

  constructor(private translocoService: TranslocoService, private cookieService: CookieService, private userData: UserDataService) { }

  getDefaultLanguage(): string {
    return this.defaultLanguage;
  }

  getAvailableLanguages(): string[] {
    return this.availableLanguages;
  }

  setLanguage(lang: string, setCookie: boolean = true): void {
    lang = lang.toLowerCase();
    if (
      !this.getAvailableLanguages().includes(lang)) {
      lang = this.getDefaultLanguage();
    }
    const cookieLang = this.cookieService.get('lang');

    try {
      this.translocoService.setActiveLang(lang);
      if (setCookie) {
        this.cookieService.set('lang', lang, { path: '/', expires: 365 });
      }
    } catch (error) {
      throw new Error(`Failed to set language: ${lang} (setCookie: ${setCookie}). Error: ${error}`);
    }
  }

  initLanguage(): void {
    const cookieLang = this.cookieService.get('lang');
    if (cookieLang) {
      this.setLanguage(cookieLang, false);
    } else {
      const browserLanguage = navigator.language.slice(0, 2);
      const finalInitLanguage = this.getAvailableLanguages().includes(browserLanguage) ? browserLanguage : this.getDefaultLanguage();
      this.setLanguage(finalInitLanguage);
    }
  }

  getCurrentUILanguage(): string {
    const cookieLang = this.cookieService.get('lang')?.toLowerCase();
    return this.getAvailableLanguages().includes(cookieLang) ? cookieLang : this.getDefaultLanguage();
  }

  async setToUserLanguage() {
    await this.userData.loadUserData(false);
    const user = this.userData.getUser();

    if (user != null) {
      const currentLanguage = this.getCurrentUILanguage().toUpperCase();
      const userLanguage = user!.settings?.ui_language;

      if (userLanguage !== currentLanguage) {
        const finalLanguage = Object.values(UiLanguage).includes(userLanguage as UiLanguage) ? (userLanguage as UiLanguage) : UiLanguage.EN;
        this.setLanguage(finalLanguage, true);
      }
    }
  }
}
